import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useNavigate } from "react-router-dom";

export default function WrongAttempts() {
  const [rows, setRows] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/me/wrong-attempts?limit=50");
        setRows(r.data || []);
      } catch { setRows([]); }
    })();
  }, []);

  if (rows === null) return <div className="text-sm text-slate-500">Yükleniyor…</div>;

  return (
    <div className="space-y-4">
      <div>
        <h1 className="font-display text-3xl tracking-tight text-[#0B1A35]">Son 50 Yanlışım</h1>
        <p className="text-slate-500 text-sm">Boş bıraktığın sorular burada görünmez.</p>
      </div>
      {rows.length === 0 ? (
        <div className="text-sm text-slate-500 border border-dashed border-slate-200 rounded-xl p-6 text-center">
          Henüz yanlış cevapladığın soru yok.
        </div>
      ) : (
        <div className="grid gap-2">
          {rows.map((a) => (
            <button
              key={a.attempt_id}
              data-testid={`wrong-attempt-${a.attempt_id}`}
              onClick={() => nav(`/inceleme/${a.session_id}`)}
              className="yz-card text-left p-3">
              <div className="text-xs font-mono text-slate-500">
                {new Date(a.created_at).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" })}
                {" · "}{a.ref}
                {a.topic_name && <> · {a.topic_name}</>}
                {a.subtopic_name && <> / {a.subtopic_name}</>}
              </div>
              <div className="text-sm mt-1 line-clamp-2">{a.text_preview || "(soru içeriği)"}</div>
              <div className="text-xs mt-1">
                <span className="text-rose-600">Cevabın: {a.selected}</span>
                <span className="text-slate-400"> · </span>
                <span className="text-emerald-600">Doğru: {a.correct}</span>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
